import type { paths } from '@pba/types-openapi-client';
import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type GroupPathRequestParams = paths['/v3/groups/{id}']['get']['parameters']['path'];
type ResponseType = paths['/v3/groups/{id}']['get']['responses']['200']['content']['application/json'];

export const getGroupDetail = async ({ routeParams: { id } }: RouteParamsRequest<GroupPathRequestParams>) =>
  apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.groups.detail(id));
